import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "documentActivityAmendment";
const endpoint = "document_activity_amendments/";

export const documentActivityAmendmentsReducer = generateItemsReducer<DocumentActivityAmendmentSnakeModel, {}>(itemType);

export const documentActivityAmendmentAndActionsFromStore = generateItemAndActionsFromStore<DocumentActivityAmendmentSnakeModel, {}, {}>(
  itemType,
  endpoint,
  (a, b, c, d) => ({}),
);

export const documentActivityAmendmentListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentActivityAmendmentAndActionsFromStore);
